import React from 'react';
import PropTypes from 'prop-types';
import ProductPrice from '../../ProductPrice';
import BasketItemControls from '../BasketItemControls';
import DefaultPicture from '../../../components/01_atoms/DefaultPicture';
import BasketBundleDetails from '../BasketBundleDetails';

import s from './index.module.scss';

const BasketItem = ({ product }) => (
  <div className={s['basket-item']}>
    <div className={s['basket-item__row']}>
      <span className={s['basket-item__image']}>
        {product.data && product.data.image && <DefaultPicture {...product.data.image} />}
      </span>

      <div className={s['basket-item__details']}>
        <div className={s['basket-item__header']}>
          <h3 className={s['basket-item__title']}>{product.data.title}</h3>
          <div className={s['basket-item__price']}>
            <ProductPrice product={product.data} />
          </div>
        </div>
        <BasketItemControls product={product} />
      </div>
    </div>
    {/* Display child products if it's a bundle. */}
    {product.data.type === 'gifts_bundle' && <BasketBundleDetails bundle={product.data} />}
  </div>
);

BasketItem.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    quantity: PropTypes.number,
    data: PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.string,
      title: PropTypes.string,
      categoryIds: PropTypes.arrayOf(PropTypes.number),
      variantType: PropTypes.string,
      annotation: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.object,
      image: PropTypes.object,
      actionImage: PropTypes.object,
      actionDescription: PropTypes.string,
      giftsInBundle: PropTypes.arrayOf(PropTypes.object),
    }),
  }).isRequired,
};

export default BasketItem;
